import ClosedEyeIcon from '../../../../icons/closed-eye.svg'
import EyeIcon from '../../../../icons/eye-filled.svg'

export function getVisibilityIcon(isVisible) {
  return isVisible ? EyeIcon : ClosedEyeIcon
}
